<section class="voice-delivery-type">
  <div class="title">Levering</div>
  <div class="delivery-options">
    @if (!canSellHardwareWithLogistics) {
      <app-ice-select-box
        label="Selg i butikk"
        radioTestId="sell-in-shop-true-input"
        type="radio"
        [control]="form.get(MobilePhoneFormControls.IsSoldInShop)"
        [readonly]="canSellHardwareWithLogistics"
        [value]="true"
      />
    }
    <app-ice-select-box
      label="Send i posten"
      radioTestId="sell-in-shop-false-input"
      type="radio"
      [control]="form.get(MobilePhoneFormControls.IsSoldInShop)"
      [disabled]="!canSellHardwareWithLogistics || isManualRegistration"
      [readonly]="canSellHardwareWithLogistics"
      [value]="false"
    />
  </div>
</section>
